import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { WithDot } from '@/components-latest/primitives/Badge'
import Button from '@/components-latest/primitives/Button'
import SearchInput from '@/components-latest/primitives/Controls/SearchInput'
import MenuFilter from '@/components-latest/ui/MenuPage/MenuFilter'
import { selectMenuFilters } from '@/ducks/menu/selectors/menu.selectors'
import { setMenuFilters } from '@/ducks/menu/slices/menu.slice'
import Filter from '../../../primitives/Icons/Filter'
import Styles from './MenuSearchToolbar.module.scss'
import omit from 'just-omit'



const MenuSearchToolbar = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const filters = useSelector(selectMenuFilters)

  const handleClear = (search: string) =>
    dispatch(setMenuFilters({ ...filters, search }))
    
  const handleSubmit = (search: string) =>
    dispatch(setMenuFilters({ ...filters, search }))

  const hasFilters =
    Object.entries(omit(filters, 'search')).filter(
      ([key, value]) => !(key === 'status' && value === 'all')
    ).length > 0

  return (
    <div data-testid="menu-search-toolbar" className={Styles.menuSearchToolbar}>
      <SearchInput
        onClear={handleClear}
        onSubmit={handleSubmit}
        placeholder={t('menu.search-placeholder')}
      />
      <MenuFilter >
        <Button
          data-testid="menu-search-toolbar-filter-trigger"
          variant="secondary"
          size="large"
          icon={
            <WithDot variant={hasFilters ? 'negative' : 'hidden'}>
              <Filter />
            </WithDot>
          }
        />
      </MenuFilter>
    </div>
  )
}

export default MenuSearchToolbar
